<template>
  <div class="sidebar-overlay" v-if="showSidebar" @click="showSidebar = false;"></div>
  <nav class="sidebar d-md-flex" :class="{ 'd-flex': showSidebar, 'd-none': !showSidebar }">
  <div style="overflow-y: auto;">
    <div class="logo">
      
      <a href="#/home">
      <img src="/images/favicon.png" alt="7th Level Technologies" style="width: 25%; max-width: 100%; height: auto;" class="mb-3">
      </a>
      <h4 class="text-white mb-0">Radar App</h4>
    </div>
    <ul class="nav flex-column">
      <li><hr /></li>
      
      <!-- Quick Actions -->
      <li class="nav-item position-relative">
        <a class="nav-link py-0 -ps-1" href="#" @click.prevent="openJobModal()">
          <span>
            <i class="fas fa-plus-circle position-absolute mt-1"></i>
            <span class="d-inline-block ms-4 ps-2">New Request</span>
          </span>
        </a>
      </li>
      <li class="nav-item position-relative">
        <a class="nav-link py-0 -ps-1" href="#" @click.prevent="openAssignmentModal()">
          <span>
            <i class="fas fa-tasks position-absolute mt-1"></i>
            <span class="d-inline-block ms-4 ps-2">New Task</span>
          </span>
        </a>
      </li>
      
      <li><hr /></li>
      
      <!-- Main Navigation -->
      <li class="nav-item position-relative">
        <router-link class="nav-link py-0 -ps-1" to="/job/list">
          <span>
            <i class="fas fa-list position-absolute mt-1"></i>
            <span class="d-inline-block ms-4 ps-2">Requests</span>
          </span>
        </router-link>
      </li>
      <li class="nav-item position-relative">
        <router-link class="nav-link py-0 -ps-1" to="/client/list">
          <span>
            <i class="fas fa-building position-absolute mt-1"></i>
            <span class="d-inline-block ms-4 ps-2">Clients</span>
          </span>
        </router-link>
      </li>
      <li class="nav-item position-relative">
        <router-link class="nav-link py-0 -ps-1" to="/tech/list">
          <span>
            <i class="fas fa-users position-absolute mt-1"></i>
            <span class="d-inline-block ms-4 ps-2">Technicians</span>
          </span>
        </router-link>
      </li>
      <li class="nav-item position-relative">
        <router-link class="nav-link py-0 -ps-1" to="/time/list">
          <span>
            <i class="fas fa-tasks position-absolute mt-1"></i>
            <span class="d-inline-block ms-4 ps-2">All Tasks</span>
          </span>
        </router-link>
      </li>
      <li class="nav-item position-relative">
        <router-link class="nav-link py-0 -ps-1" to="/calendar">
          <span>
            <i class="fas fa-calendar-alt position-absolute mt-1"></i>
            <span class="d-inline-block ms-4 ps-2">Calendar</span>
          </span>
        </router-link>
      </li>
      <li class="nav-item position-relative">
        <router-link class="nav-link py-0 -ps-1" to="/part/list">
          <span>
            <i class="fas fa-puzzle-piece position-absolute mt-1"></i>
            <span class="d-inline-block ms-4 ps-2">All Parts</span>
          </span>
        </router-link>
      </li>
      <li class="nav-item position-relative">
        <router-link class="nav-link py-0 -ps-1" to="/expense/list">
          <span>
            <i class="fas fa-hand-holding-usd position-absolute mt-1"></i>
            <span class="d-inline-block ms-4 ps-2">All Expenses</span>
          </span>
        </router-link>
      </li>
      <li class="nav-item position-relative">
        <router-link class="nav-link py-0 -ps-1" to="/mileage/list">
          <span>
            <i class="fas fa-car position-absolute mt-1"></i>
            <span class="d-inline-block ms-4 ps-2">All Mileage</span>
          </span>
        </router-link>
      </li>
      <li class="nav-item position-relative">
        <router-link class="nav-link py-0 -ps-1" to="/pm/list">
          <span>
            <i class="fas fa-wrench position-absolute mt-1"></i>
            <span class="d-inline-block ms-4 ps-2">PM List</span>
          </span>
        </router-link>
      </li>
      <li class="nav-item position-relative">
        <router-link class="nav-link py-0 -ps-1" to="/clock/list">
          <span>
            <i class="fas fa-clock position-absolute mt-1"></i>
            <span class="d-inline-block ms-4 ps-2">Time Tracker</span>
          </span>
        </router-link>
      </li>
      
      <li><hr /></li>
      
      <!-- Activity Log -->
      <li class="nav-item position-relative">
        <router-link class="nav-link py-0 -ps-1" to="/home">
          <span>
            <i class="fas fa-history position-absolute mt-1"></i>
            <span class="d-inline-block ms-4 ps-2">Activity Log</span>
          </span>
        </router-link>
      </li>
      
      <!-- Work Report -->
      <li class="nav-item position-relative">
        <router-link class="nav-link py-0 -ps-1" to="/reports/work">
          <span>
            <i class="fas fa-file-invoice position-absolute mt-1"></i>
            <span class="d-inline-block ms-4 ps-2">Work Report</span>
          </span>
        </router-link>
      </li>
      
      <li><hr /></li>
    </ul>
  </div>
  <div>
    <ul class="nav flex-column">
      <li class="nav-item position-relative">
        <router-link class="nav-link py-0 -ps-1" to="/logout">
          <span>
          <i class="fas fa-right-from-bracket position-absolute mt-1"></i>
          <span class="d-inline-block ms-4 ps-2">Logout</span>
          </span>
        </router-link>
      </li>
    </ul>
    <div class="version">
      App Version 1.0.0
    </div>
  </div>
  </nav>
</template>

<script lang="ts" setup>
import { ref } from "vue";
import { RouterLink } from "vue-router";
import Emitter from "@/services/Emitter";
const _ = ref({});

const showSidebar = ref(false);
Emitter.on("sidebar", () => {
  showSidebar.value = !showSidebar.value;  
});

const openJobModal = () => {
  Emitter.emit("open-job-modal");
  showSidebar.value = false; // Close sidebar on mobile after opening modal
};

const openAssignmentModal = () => {
  Emitter.emit("open-assignment-modal");
  showSidebar.value = false; // Close sidebar on mobile after opening modal
};


</script>

<style scoped>
.sidebar {
  min-width: 300px;
  background-color: rgb(34,30,31);
  color: #ffffff;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  z-index:1000;
}
.sidebar .logo {
  padding: 1.5rem;
  text-align: center;
}
.sidebar .nav-link {
  color: #adb5bd;
  /* padding: 0.75rem 1.5rem; */
}

.sidebar .nav-link > span {
  display: block;
  padding: 0.75rem 1.5rem;
  /* border-radius: 50px; */
}

.sidebar .nav-link:hover > * {
  color: #ffffff; 
  /* background-color: #495057; */
  transition: padding-left 0.4s;
  padding-left: 2rem!important;
}
.sidebar .nav-link:hover i {
  color: rgb(214, 44, 54);
}

.sidebar .nav-link:hover > span {
  background-color: #495057;
  box-shadow: inset 2px 2px 5px rgba(0, 0, 0, 0.2);
}

.sidebar .nav-link:hover > span i:last-child {
  display: inline-block!important;
}

/* Active page styles - match hover state */
.sidebar .nav-link.router-link-active > * {
  color: #ffffff;
  padding-left: 2rem!important;
}

.sidebar .nav-link.router-link-active i {
  color: rgb(214, 44, 54);
}

.sidebar .nav-link.router-link-active > span {
  background-color: #495057;
  box-shadow: inset 2px 2px 5px rgba(0, 0, 0, 0.2);
}

.sidebar .version {
  padding: 1rem;
  color: #6c757d;
  font-size: 0.875rem;
  text-align: center;
}

.sidebar-overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index:999;
}
</style>